

// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import ImageGallery from '../components/ImageGallery';
// import { ChevronDown } from 'lucide-react';

// const HomePage = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);

//   const offerings = [
//     {
//       title: "Pengurusan Automasi Pusat Sumber",
//       description: "Sistem pengurusan komprehensif untuk pusat sumber sekolah",
//       defaultImage: "/pengurusan sistem zabra_1 bnw.png",
//       hoverImage: "/pengurusan sistem zabra_1.png"
//     },
//     {
//       title: "Kad ID Murid dan Guru",
//       description: "Kad ID yang boleh disesuaikan untuk murid dan guru",
//       defaultImage: "/kad matrik murid zabra_1 bnw.png",
//       hoverImage: "/kad matrik murid zabra_1.png"
//     },
//     {
//       title: "Servis Baiki Komputer",
//       description: "Perkhidmatan pembaikan pakar untuk semua jenis komputer",
//       defaultImage: "/baiki komputer zabra_1 bnw.png",
//       hoverImage: "/baiki komputer zabra_1.png"
//     }
//   ];

//   const services = [
//     { title: "Carian LAN-OPAC", description: "Sistem carian buku dalam talian untuk pustakawan dan murid", image: "/icons/search.png" },
//     { title: "Pengurusan Bahan Buku dan Murid", description: "Pengurusan efisien untuk bahan bacaan dan rekod murid", image: "/icons/daftar bahan zabra.png" },
//     { title: "Operasi Pinjam Pulang", description: "Sistem pinjaman dan pemulangan buku yang mudah dan cepat", image: "/icons/operasi pinjam pulang zabra.png" },
//     { title: "Pengurusan Inventori", description: "Pengurusan inventori yang tepat dan kemas kini", image: "/icons/inventori buku zabra.png" },
//     { title: "Laporan dan Statistik", description: "Penjanaan laporan terperinci dan statistik penggunaan", image: "/icons/report analysis zabra.png" },
//     { title: "Sistem Kehadiran Pusat Sumber", description: "Pemantauan kehadiran murid di pusat sumber", image: "/icons/sistem kehadiran zabra.png" }
//   ];

//   const scrollToNextSection = () => {
//     const nextSection = document.getElementById('kami-tawarkan');
//     if (nextSection) {
//       nextSection.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   return (
//     <div className="bg-white">

// <section className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-b from-gray-100 to-white py-5 px-4">
//         <div className="container mx-auto">
//           <div className="flex flex-col md:flex-row items-center md:justify-between">
//             <div className="md:w-1/2 text-center md:text-left mb-8 md:mb-0 md:pr-12">
//               <motion.h1 
//                 initial={{ opacity: 0, y: -20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//                 className="text-3xl md:text-6xl font-bold mb-6 text-[#F29200] leading-tight"
//               >
//                 Memudahkan Operasi Pusat Sumber Sekolah
//               </motion.h1>
//               <motion.p 
//                 initial={{ opacity: 0, y: -20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8, delay: 0.2 }}
//                 className="text-xl mb-8 text-gray-700"
//               >
//                 Menyediakan sistem Inovatif, mesra pengguna dan seronok bagi murid-murid sekolah
//               </motion.p>
//               <motion.div
//                 initial={{ opacity: 0, y: -20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8, delay: 0.4 }}
//               >
//                 <Link to="/contact" className="bg-[#F29200] text-white py-3 px-8 rounded-full font-semibold hover:bg-[#D97E00] transition duration-300 text-lg inline-block">
//                   Hubungi Kami
//                 </Link>
//               </motion.div>
//             </div>
//             <motion.div 
//               initial={{ opacity: 0, scale: 0.9 }}
//               animate={{ opacity: 1, scale: 1 }}
//               transition={{ duration: 0.8, delay: 0.6 }}
//               className="md:w-1/2 mt-8 md:mt-0 md:pl-12"
//             >
//               <img src="/ZABRA-MAIN.jpeg" alt="Company overview" className="rounded-lg shadow-xl w-full max-w-3xl mx-auto" />
//             </motion.div>
//           </div>
//         </div>
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8, delay: 1 }}
//           className="mt-12 animate-bounce"
//           onClick={scrollToNextSection}
//         >
//           <ChevronDown size={48} className="text-[#F29200] cursor-pointer" />
//         </motion.div>
//       </section>

//       <section className="py-5 bg-gray-100">
//         <div className="container mx-auto px-4">
//           {/* <h2 className="text-3xl font-bold mb-12 text-center text-[#F29200]">Gallery</h2> */}
//           <ImageGallery />
//         </div>
//       </section>

//       <section id="kami-tawarkan" className="pt-20 pb-5 bg-gray-100">
//         <div className="container mx-auto px-4">
//           <h2 className="text-3xl font-bold mb-12 text-center text-[#F29200]">KAMI MENYEDIAKAN</h2>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 ">
//             {offerings.map((offering, index) => (
//               <motion.div 
//                 key={index} 
//                 className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 flex flex-col"
//                 onMouseEnter={() => setHoveredCard(index)}
//                 onMouseLeave={() => setHoveredCard(null)}
//                 whileHover={{ scale: 1.05 }}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//               >
//                 <div className="mb-4 flex-grow flex items-center justify-center h-48 ">
//                   <img 
//                     src={hoveredCard === index ? offering.hoverImage : offering.defaultImage} 
//                     alt={offering.title}
//                     className="max-w-full max-h-full object-contain transition-all duration-300 "
//                   />
//                 </div>
//                 <h3 className="text-xl font-semibold mb-4 text-[#F29200] text-center">{offering.title}</h3>
//                 <p className="text-gray-600">{offering.description}</p>
//               </motion.div>
//             ))}
//           </div>
//           <div className="text-center py-5">
//               <Link to="/contact" className="bg-[#F29200] text-white py-3 px-8 rounded-full font-semibold hover:bg-[#D97E00] transition duration-300 text-lg inline-block">
//                 Hubungi kami
//               </Link>
//           </div>
//         </div>
//       </section>

//       {/* SISTEM ZABRA Section */}
//       <section id="services" className="py-5">
//         <div className="container mx-auto px-4">
//           <h2 className="text-3xl font-bold mb-12 text-center text-[#F29200]">SISTEM ZABRA SOLUTIONS</h2>
//           <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
//             {services.map((service, index) => (
//               <div 
//                 key={index} 
//                 className="bg-white p-4 sm:p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 flex flex-col transform hover:scale-105"
//               >
//                 <div className="mb-3 sm:mb-4 flex-grow flex items-center justify-center h-24 sm:h-32 md:h-48">
//                   <img 
//                     src={service.image} 
//                     alt={service.title}
//                     className="max-w-full max-h-full object-contain"
//                   />
//                 </div>
//                 <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-4 text-[#F29200]">{service.title}</h3>
//                 <p className="text-sm sm:text-base text-gray-600">{service.description}</p>
//               </div>
//             ))}
//           </div>

//           <div className="text-center py-5">
//               <Link to="/contact" className="bg-[#F29200] text-white py-3 px-8 rounded-full font-semibold hover:bg-[#D97E00] transition duration-300 text-lg inline-block">
//                 Hubungi kami
//               </Link>
//           </div>
               
//         </div>
//       </section>

      
//     </div>
//   );
// };

// export default HomePage;

import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ImageGallery from '../components/ImageGallery';
import { ArrowRight, Wrench, StickyNote } from 'lucide-react';
import { OrangeScatter, OrangeSlice } from '../components/OrangeSlice';
import TvHero from '../components/TvHero';
import PcShowcase from '../components/PcShowcase';
import VideoWall from '../components/VideoWall';

const HomePage = () => {
  const offerings = [
    {
      title: "Aplikasi Sistem Pusat Sumber Digital",
      description: "Sistem pengurusan komprehensif untuk pusat sumber",
      icon: "/pengurusan sistem zabra_1.png",
      folder: "/01pengurusan_automasi",
      base: "urus",
      // login screen first (crisp), rest are blurred a touch & interleaved
      screens: [
        "0-login page.png",
        "1-dashboard.png",
        "2-dashboard.png",
        "3-bahan-daftar bahan & pencarian.png",
        "7-bahan-print barkod & tulang buku (standard barkod).png",
        "17-anugerah-papan markah (leaderboard).png",
      ],
    },
    {
      title: "Kad ID Murid dan Guru",
      description: "Kad ID yang disesuaikan untuk murid dan guru mengikut standard",
      icon: "/kad matrik murid zabra_1.png",
      folder: "/02kad_id",
      base: "kad"
    },
    {
      title: "Servis & Konsultasi Komputer",
      description: "Perkhidmatan pembaikan pakar untuk semua jenis komputer",
      icon: "/baiki komputer zabra_1.png",
      folder: "/03servis_baiki",
      base: "baiki"
    }
  ];

  const services = [
    { title: "Carian LAN-OPAC", description: "Sistem carian buku dalam talian untuk pustakawan dan murid", image: "/icons/search.png", category: "Carian" },
    { title: "Pengurusan Bahan Buku dan Murid", description: "Pengurusan efisien untuk bahan bacaan dan rekod murid", image: "/icons/daftar bahan zabra.png", category: "Pengurusan" },
    { title: "Operasi Pinjam Pulang Pantas", description: "Sistem pinjaman dan pemulangan buku yang mudah dan cepat", image: "/icons/operasi pinjam pulang zabra.png", category: "Operasi" },
    { title: "Pengurusan Inventori", description: "Pengurusan inventori yang tepat dan kemas kini", image: "/icons/inventori buku zabra.png", category: "Pengurusan" },
    { title: "Laporan dan Statistik", description: "Penjanaan laporan terperinci dan statistik penggunaan", image: "/icons/report analysis zabra.png", category: "Laporan" },
    { title: "Sistem Kehadiran Pusat Sumber", description: "Pemantauan kehadiran murid di pusat sumber", image: "/icons/sistem kehadiran zabra.png", category: "Operasi" }
  ];

  const scrollToNextSection = () => {
    const nextSection = document.getElementById('services');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-white overflow-x-clip">
      {/* ============ HERO — bold & energetic, ZS monogram watermark ============ */}
      <section className="relative min-h-screen flex flex-col justify-center monogram-orange monogram-orange--bold px-4 pt-24 pb-20">
        <div className="absolute inset-0 bg-gradient-to-b from-white/75 via-white/55 to-white pointer-events-none z-0" />
        <div className="container mx-auto relative z-10">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
            {/* Left: copy */}
            <div className="lg:w-1/2 w-full">
              <motion.span
                initial={{ opacity: 0, y: -12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="z-eyebrow mb-6"
              >
                <OrangeSlice className="w-4 h-4" /> Sistem Pusat Sumber 
                <span className="
                bg-gradient-to-r from-cyan-600 to-blue-600 
                text-transparent bg-clip-text
                tracking-widest
                font-extrabold
                animate-pulse
              ">
                DIGITAL
              </span>
              </motion.span>
              <motion.h1
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="font-serif-display text-5xl sm:text-6xl md:text-7xl xl:text-8xl font-bold leading-[0.95] tracking-tight text-[var(--z-ink)] mt-2"
              >
                Uruskan 
                <br />Pusat Sumber<br />
                dengan <span className="z-highlight">Seronok.</span>
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="text-lg md:text-2xl mt-7 mb-9 text-[var(--z-muted)] max-w-2xl font-medium"
              >
                Sistem Digital dan Mesra Pengguna yang memudahkan operasi Pusat Sumber — direka untuk GURU, disukai MURID.
              </motion.p>
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                className="flex flex-wrap gap-4"
              >
                <Link to="/contact" className="btn-accent text-lg">
                  Hubungi Kami <ArrowRight size={20} />
                </Link>
                <a href="#services" onClick={(e) => { e.preventDefault(); scrollToNextSection(); }} className="btn-outline text-lg">
                  Lihat Perkhidmatan
                </a>
              </motion.div>
            </div>

            {/* Right: TVPSS-themed channel display filling the empty space */}
            <motion.div
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="lg:w-1/2 w-full relative"
            >
              <TvHero />
            </motion.div>
          </div>
        </div>
      </section>

      {/* ============ SERVICES — simple, compact ============ */}
      <section id="services" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <span className="z-eyebrow">Ekosistem Kami</span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-bold mt-3 text-[var(--z-ink)]">
              Sistem Zabra Solutions
            </h2>
          </div>

          <div className="grid grid-cols-3 md:grid-cols-6 gap-2 sm:gap-3">
            {services.map((service) => (
              <div
                key={service.title}
                className="z-card-soft px-2 py-4 flex flex-col items-center text-center"
              >
                <div className="mb-2 flex items-center justify-center h-12 sm:h-14">
                  <img src={service.image} alt={service.title} className="max-w-full max-h-full object-contain" />
                </div>
                <h3 className="font-serif-display text-xs sm:text-sm font-bold text-[var(--z-ink)] leading-tight">{service.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ OFFERINGS — alternating story layout ============ */}
      <section id="kami-tawarkan" className="py-24 border-y-2 border-[var(--z-ink)] monogram-orange">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="z-eyebrow">Apa Yang Kami Sediakan</span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-bold mt-3 text-[var(--z-ink)]">Kami Menyediakan</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
            {offerings.map((offering, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex flex-col rounded-3xl border-2 border-[var(--z-ink)] bg-white p-6 shadow-[6px_6px_0_0_var(--z-ink)]"
              >
                {/* PC monitor showcasing this offering's folder photos */}
                <PcShowcase
                  folder={offering.folder}
                  base={offering.base}
                  alt={offering.title}
                  delay={index * 900}
                  screens={offering.screens}
                />

                {/* Copy */}
                <div className="mt-6 flex flex-col flex-grow">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="grid place-items-center h-11 w-11 rounded-xl border-2 border-[var(--z-ink)] bg-white shadow-[3px_3px_0_0_var(--z-accent)] shrink-0">
                      <img src={offering.icon} alt="" className="h-7 w-7 object-contain" />
                    </div>
                    <span className="font-serif-display text-4xl font-bold text-[var(--z-accent)]/25 leading-none">
                      0{index + 1}
                    </span>
                  </div>
                  <h3 className="font-serif-display text-2xl font-bold mb-2 text-[var(--z-ink)] leading-tight">{offering.title}</h3>
                  <p className="text-[var(--z-muted)] leading-relaxed mb-5 flex-grow">{offering.description}</p>
                  <Link to="/contact" className="inline-flex items-center gap-2 font-bold text-[var(--z-accent-700)] hover:gap-3 transition-all mt-auto">
                    Ketahui Lebih Lanjut <ArrowRight size={18} />
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>

        </div>

        {/* ---- Interactive workshop: its own "garage" world (full-bleed) ---- */}
        <div className="garage-world relative mt-24 border-t-4 border-[var(--z-accent)] py-16 md:py-20 px-4">
          {/* hazard stripe along the top edge */}
          <div className="garage-hazard absolute inset-x-0 top-0 h-2" />

          <div className="container mx-auto relative">
            <div className="max-w-3xl mx-auto text-center mb-8">
              <span className="garage-badge">
                <Wrench size={13} /> Bengkel Interaktif
              </span>
              <h3 className="font-serif-display text-3xl md:text-5xl font-bold mt-4 text-white">
                Lihat <span className="text-[var(--z-accent)]">Solutions</span> Kami
              </h3>
             
            </div>



            <VideoWall offerings={offerings} dark />
          </div>
        </div>
      </section>

      {/* ============ GALLERY — bold band, last ============ */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="z-eyebrow">Galeri</span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-bold mt-3 text-[var(--z-ink)]">Gerak kerja kami</h2>
          </div>
          <ImageGallery />
        </div>
      </section>

      {/* ============ CTA — full amber block ============ */}
      <section className="relative z-amber-block overflow-hidden">
        <OrangeScatter className="opacity-40" />
        <div className="container mx-auto px-4 py-20 md:py-28 text-center relative">
          <h2 className="font-serif-display text-4xl md:text-6xl font-bold text-white leading-tight">
            Sedia untuk mula?
          </h2>
          <p className="text-white/90 text-lg md:text-xl mt-4 mb-9 max-w-2xl mx-auto font-medium">
            Mari bincangkan keperluan Pusat Sumber anda hari ini.
          </p>
          <Link to="/contact" className="btn-outline text-lg !border-white !text-[var(--z-ink)] !shadow-[0_6px_0_0_rgba(0,0,0,0.35)]">
            Hubungi Kami Sekarang <ArrowRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;


